import React, { Component } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// const  policy =  " Privacy Policy for Vertace At uKiddiy, accessible from https://police-dev.vertace.net, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by uKiddiy and how we use it.

// If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.

// This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in uKiddiy. This policy is not applicable to any information collected offline or via channels other than this website. Our Privacy Policy was created with the help of the TermsFeed Privacy Policy Generator.

// Consent
// By using our website, you hereby consent to our Privacy Policy and agree to its terms.

// Information we collect
// The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.

// If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.

// When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.

// How we use your information
// We use the information we collect in various ways, including to:

// Provide, operate, and maintain our website
// Improve, personalize, and expand our website
// Understand and analyze how you use our website
// Develop new products, services, features, and functionality
// Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes
// Send you emails
// Find and prevent fraud
// Log Files
// uKiddiy follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.

// Cookies and Web Beacons
// Like any other website, uKiddiy uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.

// For more general information on cookies, please read "Cookies" article from the Privacy Policy Generator.

// Advertising Partners Privacy Policies
// You may consult this list to find the Privacy Policy for each of the advertising partners of uKiddiy.

// Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on uKiddiy, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.

// Note that uKiddiy has no access to or control over these cookies that are used by third-party advertisers.

// Third Party Privacy Policies
// uKiddiy's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.

// You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.

// CCPA Privacy Rights (Do Not Sell My Personal Information)
// Under the CCPA, among other rights, California consumers have the right to:

// Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.

// Request that a business delete any personal data about the consumer that a business has collected.

// Request that a business that sells a consumer's personal data, not sell the consumer's personal data.

// If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.

// GDPR Data Protection Rights
// We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:

// The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.

// The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.

// The right to erasure – You have the right to request that we erase your personal data, under certain conditions.

// The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.

// The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.

// The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.

// If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.

//hildren's Information C
// Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.

// uKiddiy does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records."

class PagesFaqs extends Component {
  constructor() {
    super()
    this.state = {
      activeTab: "3",
    }
    this.toggleTab = this.toggleTab.bind(this)
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <h3>Privacy Policy for Vertace </h3>

            <div className="checkout-tabs">
              <Row>
                <Col lg="12 mt-2">
                  <Card>
                    <CardBody>
                      <TabContent activeTab={this.state.activeTab}>
                        {/* <TabPane tabId="1"> */}
                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <p className="text-muted">
                              At uKiddiy, accessible from https://ukiddiy.com,
                              one of our main priorities is the privacy of our
                              visitors. This Privacy Policy document contains
                              types of information that is collected and
                              recorded by uKiddiy and how we use it.
                            </p>

                            <p className="text-muted">
                              If you have additional questions or require more
                              information about our Privacy Policy, do not
                              hesitate to contact us.
                            </p>
                            <p className="text-muted">
                              This Privacy Policy applies only to our online
                              activities and is valid for visitors to our
                              website with regards to the information that they
                              shared and/or collect in uKiddiy. This policy is
                              not applicable to any information collected
                              offline or via channels other than this website.
                              Our Privacy Policy was created with the help of
                              the TermsFeed Privacy Policy Generator.{" "}
                            </p>
                          </Media>
                        </Media>
                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">Consent</h5>
                            <p className="text-muted">
                              By using our website, you hereby consent to our
                              Privacy Policy and agree to its terms.
                            </p>
                          </Media>
                        </Media>
                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              Information we collect
                            </h5>
                            <p className="text-muted">
                              The personal information that you are asked to
                              provide, and the reasons why you are asked to
                              provide it, will be made clear to you at the point
                              we ask you to provide your personal information.
                            </p>

                            <p className="text-muted">
                              If you contact us directly, we may receive
                              additional information about you such as your
                              name, email address, phone number, the contents of
                              the message and/or attachments you may send us,
                              and any other information you may choose to
                              provide.{" "}
                            </p>

                            <p className="text-muted">
                              When you register for an Account, we may ask for
                              your contact information, including items such as
                              name, company name, address, email address, and
                              telephone number.
                            </p>
                          </Media>
                        </Media>
                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              We use the information we collect in various ways,
                              including to:
                            </h5>
                            <ul>
                              <li className="text-muted">
                                Provide, operate, and maintain our website.
                              </li>
                              <li className="text-muted">
                                Improve, personalize, and expand our website.
                              </li>
                              <li className="text-muted">
                                Develop new products, services, features, and
                                functionality.
                              </li>
                              <li className="text-muted">
                                Provide, operate, and maintain our website.
                              </li>
                              <li className="text-muted">
                                Communicate with you, either directly or through
                                one of our partners, including for customer
                                service, to provide you with updates and other
                                information relating to the website, and for
                                marketing and promotional purposes.
                              </li>
                              <li className="text-muted">Send you emails.</li>
                              <li className="text-muted">
                                Find and prevent fraud.
                              </li>
                            </ul>
                            {/* <p className="text-muted">
                              Provide, operate, and maintain our website.
                            </p>
                            <p className="text-muted">
                              Improve, personalize, and expand our website.
                            </p>
                            <p className="text-muted">
                              Develop new products, services, features, and
                              functionality.
                            </p>
                            <p className="text-muted">
                              Provide, operate, and maintain our website.
                            </p>
                            <p className="text-muted">
                              Communicate with you, either directly or through
                              one of our partners, including for customer
                              service, to provide you with updates and other
                              information relating to the website, and for
                              marketing and promotional purposes.
                            </p>
                            <p className="text-muted">Send you emails.</p>
                            <p className="text-muted">
                              Find and prevent fraud.
                            </p> */}
                          </Media>
                        </Media>
                        <Media className="faq-box">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">Log Files</h5>
                            <p className="text-muted">
                              uKiddiy follows a standard procedure of using log
                              files. These files log visitors when they visit
                              websites. All hosting companies do this and a part
                              of hosting services' analytics. The information
                              collected by log files include internet protocol
                              (IP) addresses, browser type, Internet Service
                              Provider (ISP), date and time stamp,
                              referring/exit pages, and possibly the number of
                              clicks. These are not linked to any information
                              that is personally identifiable. The purpose of
                              the information is for analyzing trends,
                              administering the site, tracking users' movement
                              on the website, and gathering demographic
                              information.
                            </p>
                          </Media>
                        </Media>
                        {/* </TabPane>
                        <TabPane tabId="2">
                          <CardTitle className="mb-5">Privacy Policy</CardTitle> */}

                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                            {/* <i class="fas fa-user-secret"></i> */}
                            {/* <i class="fas fa-lock"></i> */}
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              Cookies and Web Beacons
                            </h5>
                            <p className="text-muted">
                              Like any other website, uKiddiy uses 'cookies'.
                              These cookies are used to store information
                              including visitors' preferences, and the pages on
                              the website that the visitor accessed or visited.
                              The information is used to optimize the users'
                              experience by customizing our web page content
                              based on visitors' browser type and/or other
                              information.For more general information on
                              cookies, please read "Cookies" article from the
                              Privacy Policy Generator.
                            </p>
                          </Media>
                        </Media>
                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              Advertising Partners Privacy Policies
                            </h5>
                            <p className="text-muted">
                              You may consult this list to find the Privacy
                              Policy for each of the advertising partners of
                              uKiddiy.
                            </p>
                            <p className="text-muted">
                              Third-party ad servers or ad networks uses
                              technologies like cookies, JavaScript, or Web
                              Beacons that are used in their respective
                              advertisements and links that appear on uKiddiy ,
                              which are sent directly to users' browser. They
                              automatically receive your IP address when this
                              occurs. These technologies are used to measure the
                              effectiveness of their advertising campaigns
                              and/or to personalize the advertising content that
                              you see on websites that you visit.
                            </p>
                            <p className="text-muted">
                              Note that uKiddiy has no access to or control over
                              these cookies that are used by third-party
                              advertisers.
                            </p>
                          </Media>
                        </Media>
                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              Third Party Privacy Policies
                            </h5>
                            <p className="text-muted">
                              uKiddiy's Privacy Policy does not apply to other
                              advertisers or websites. Thus, we are advising you
                              to consult the respective Privacy Policies of
                              these third-party ad servers for more detailed
                              information. It may include their practices and
                              instructions about how to opt-out of certain
                              options.
                            </p>
                            <p className="text-muted">
                              Note that uKiddiy has no access to or control over
                              these cookies that are used by third-party
                              advertisers.
                            </p>
                          </Media>
                        </Media>
                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              CCPA Privacy Rights (Do Not Sell My Personal
                              Information)
                            </h5>
                            <p className="text-muted">
                              Under the CCPA, among other rights, California
                              consumers have the right to:
                            </p>
                            <ul>
                              <li className="text-muted">
                                Request that a business that collects a
                                consumer's personal data disclose the categories
                                and specific pieces of personal data that a
                                business has collected about consumers.
                              </li>
                              <li className="text-muted">
                                Request that a business delete any personal data
                                about the consumer that a business has
                                collected.
                              </li>
                              <li className="text-muted">
                                Request that a business that sells a consumer's
                                personal data, not sell the consumer's personal
                                data.
                              </li>
                              <li className="text-muted">
                                If you make a request, we have one month to
                                respond to you. If you would like to exercise
                                any of these rights, please contact us.
                              </li>
                            </ul>
                          </Media>
                        </Media>
                        <Media className="faq-box">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              GDPR Data Protection Rights
                            </h5>
                            <p className="text-muted">
                              We would like to make sure you are fully aware of
                              all of your data protection rights. Every user is
                              entitled to the following:
                            </p>
                            <ul>
                              <li className="text-muted">
                                The right to access – You have the right to
                                request copies of your personal data. We may
                                charge you a small fee for this service.
                              </li>
                              <li className="text-muted">
                                The right to rectification – You have the right
                                to request that we correct any information you
                                believe is inaccurate. You also have the right
                                to request that we complete the information you
                                believe is incomplete.
                              </li>
                              <li className="text-muted">
                                The right to erasure – You have the right to
                                request that we erase your personal data, under
                                certain conditions.
                              </li>
                              <li className="text-muted">
                                The right to restrict processing – You have the
                                right to request that we restrict the processing
                                of your personal data, under certain conditions.
                              </li>
                              <li className="text-muted">
                                The right to object to processing – You have the
                                right to object to our processing of your
                                personal data, under certain conditions.
                              </li>
                              <li className="text-muted">
                                The right to data portability – You have the
                                right to request that we transfer the data that
                                we have collected to another organization, or
                                directly to you, under certain conditions.
                              </li>
                              <li className="text-muted">
                                If you make a request, we have one month to
                                respond to you. If you would like to exercise
                                any of these rights, please contact us.
                              </li>
                            </ul>
                          </Media>
                        </Media>
                        {/* </TabPane> */}
                        {/* <TabPane tabId="3">
                          <CardTitle className="mb-5">Support</CardTitle> */}

                        <Media className="faq-box mb-4">
                          <div className="faq-icon me-3">
                            <i className="fas fa-lock font-size-20 text-success" />
                          </div>
                          <Media body>
                            <h5 className="font-size-15">
                              Children's Information C
                            </h5>
                            <p className="text-muted">
                              Another part of our priority is adding protection
                              for children while using the internet. We
                              encourage parents and guardians to observe,
                              participate in, and/or monitor and guide their
                              online activity.
                            </p>
                            <p className="text-muted">
                              uKiddiy does not knowingly collect any Personal
                              Identifiable Information from children under the
                              age of 13. If you think that your child provided
                              this kind of information on our website, we
                              strongly encourage you to contact us immediately
                              and we will do our best efforts to promptly remove
                              such information from our records."
                            </p>
                          </Media>
                        </Media>
                        {/* <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                                Where does it come from?
                              </h5>
                              <p className="text-muted">
                                Everyone realizes why a new common language
                                would be desirable one could refuse to pay
                                expensive translators.
                              </p>
                            </Media>
                          </Media>

                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                                Why do we use it?
                              </h5>
                              <p className="text-muted">
                                Their separate existence is a myth.For science,
                                music, sport, etc, Europe uses the same
                                vocabulary.
                              </p>
                            </Media>
                          </Media>
                          <Media className="faq-box mb-4">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                                Where can I get some?
                              </h5>
                              <p className="text-muted">
                                If several languages coalesce, the grammar of
                                the resulting language is more simple and
                                regular than that of the individual languages.
                              </p>
                            </Media>
                          </Media>

                          <Media className="faq-box">
                            <div className="faq-icon me-3">
                              <i className="bx bx-help-circle font-size-20 text-success" />
                            </div>
                            <Media body>
                              <h5 className="font-size-15">
                                What is Lorem Ipsum?
                              </h5>
                              <p className="text-muted">
                                New common language will be more simple and
                                regular than the existing European languages.It
                                will be as simple as occidental.
                              </p>
                            </Media>
                          </Media>
                        </TabPane> */}
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default PagesFaqs
